import React from "react";
export const LinkPill = ({ label, href, purpose = "regular-button", iconUrl, openNewTab = false, onClick, }) => (React.createElement("a", { className: `link-pill link-pill--${purpose}`, href: href, target: openNewTab ? "_blank" : undefined, rel: openNewTab ? "noreferrer" : undefined, onClick: onClick },
    iconUrl && React.createElement("img", { src: iconUrl, alt: label }),
    label));
